export const MODAL_ACTIONS = {
  HIDE_ALL_MODAL: 'MODAL_ACTIONS:HIDE_ALL_MODAL',
  TOGGLE_MODAL: 'MODAL_ACTIONS:TOGGLE_MODAL',
};
